import { nameFromEmail } from "src/utils/users.utils";
import { listFields, strapiAPIUrl, strapiMediaUrl } from "../config";
import { FIELDS_TYPES, STRAPI_FIELDS_TYPES } from "../config/type.config";
import store from "src/store";
import { getFieldMapping } from "../config/systemSwitch";
import { changeTimeZone } from "src/constants/config";
import { resolveResourceUrl } from "src/utils/url.utils";

// Функция для создания объекта пользователя из email
const createUserFromEmail = (email: string) => {
  if (!email) return null;

  const user = store.getState().users.items[email];

  if (user) {
    return {
      id: user.Id,
      email: user.Email,
      username: user.Email,
      Name: user.DisplayName,
      Title: user.DisplayName,
    };
  }

  // Fallback - создаем объект из email
  return {
    id: 0,
    email: email,
    username: email,
    Name: nameFromEmail(email),
    Title: nameFromEmail(email),
  };
};

export const prepareAddRequest = (
  listName: string,
  dataObj: Record<string, any>
) => {
  let requestObj = {};
  const fieldsObj = preapreFieldsObj(listName);
  Object.keys(dataObj).map((fieldName) => {
    if (fieldsObj[fieldName]) {
      requestObj = { ...requestObj, [fieldName]: dataObj[fieldName] };
    }
  });

  return { data: requestObj };
};

export const prepareRequest = (
  listName: string,
  sort: any,
  page: number,
  rowLimit: number,
  filter: any,
  populateFields?: Record<string, string[]>
) => {
  let fieldsArr: string[] = [];
  let populateArr: string[] = [];
  let fieldsText = "";
  let populateText = "";
  let requestText = "";

  Object.values(listFields[listName as keyof typeof listFields]).forEach(
    (field) => {
      if (
        field === FIELDS_TYPES.LOOKUP ||
        field === FIELDS_TYPES.MULTI_LOOKUP
      ) {
        if (!field) populateArr = [...populateArr, field];
      } else {
        if (!field) fieldsArr = [...fieldsArr, field];
      }
    }
  );

  fieldsArr.map((fieldName, index) => {
    fieldsText += `${index === 0 ? "?" : "&"}fields[${index}]=${fieldName}`;
  });
  // Обрабатываем populate поля
  if (populateFields && Object.keys(populateFields).length > 0) {
    let populateIndex = 0;
    Object.entries(populateFields).forEach(([fieldName, fieldsToPopulate]) => {
      if (fieldsToPopulate.length > 0) {
        // Если передается массив полей - загружаем все поля из lookup
        populateText += `&populate[${populateIndex}][${fieldName}][populate]=*`;
        populateIndex++;
      } else {
        // Если массив пустой - загружаем только базовые поля
        populateText += `&populate[${populateIndex}]=${fieldName}`;
        populateIndex++;
      }
    });
  } else {
    // Fallback - загружаем все данные
    populateArr.map((fieldName, index) => {
      populateText += `&populate[${index}][populate]=*`;
    });
  }

  requestText += fieldsText;
  requestText += populateText;
  if (sort) {
    requestText += `&sort[0]=${sort.field}:${sort.order}`;
  }
  if (page) {
    requestText += `&pagination[page]=${page}`;
  }
  if (rowLimit) {
    requestText += `&pagination[pageSize]=${rowLimit}`;
  }

  if (filter && Object.keys(filter).length > 0) {
    let i = 0;
    Object.keys(filter).map((key) => {
      if (filter[key] && filter[key].value) {
        if (filter[key].type === FIELDS_TYPES.LOOKUP) {
          requestText += `&filters[${key}][id][$eq][${i}]=${filter[key].value}`;
        } else if (filter[key].type === FIELDS_TYPES.ID) {
          requestText += `&filters[${key === "ID" ? "id" : key}][$eq][${i}]=${filter[key].value
            }`;
        } else {
          requestText += `&filters[${key === "ID" ? "id" : key}][$eq][${i}]=${filter[key].value
            }`;
        }
        i++;
      }
    });
  }
  return requestText;
};

const preapreFieldsObj = (listName: string) => {
  let fieldsObj: Record<string, any> = {};
  console.log("listName", listName);
  Object.values(listFields[listName as keyof typeof listFields]).forEach(
    (field: any) => {
      fieldsObj[field] = field;
    }
  );
  return fieldsObj;
};

export const prepareContentTypeResponse = (
  listName: string,
  respnonse: any
) => {
  let convertedObj: Record<string, any> = {};
  const fieldsObj = preapreFieldsObj(listName);
  if (
    respnonse &&
    respnonse.data &&
    respnonse.data.schema &&
    respnonse.data.schema.attributes
  ) {
    Object.keys(respnonse.data.schema.attributes).map((fieldName) => {
      if (
        fieldsObj[fieldName] &&
        fieldsObj[fieldName].Type === STRAPI_FIELDS_TYPES.ENUMERATION &&
        respnonse.data.schema.attributes[fieldName].type ===
        STRAPI_FIELDS_TYPES.ENUMERATION
      ) {
        convertedObj = {
          ...convertedObj,
          [fieldName]: {
            title: fieldName,
            id: fieldName,
            results: respnonse.data.schema.attributes[fieldName].enum,
          },
        };
      }
    });
  }
  return convertedObj;
};

// Helpers to resolve preferred values with fallback
const resolveFirstDefined = (sources: any[], keys: string[]) => {
  for (const src of sources) {
    for (const key of keys) {
      const value = src && src[key];
      if (value !== undefined && value !== null) {
        return value;
      }
    }
  }
  return null;
};

const resolveUserPreferred = (itemObj: any, item: any, keys: string[]) => {
  const value = resolveFirstDefined([itemObj, item], keys);
  return processUserField(value);
};

const resolveDatePreferred = (itemObj: any, item: any, keys: string[]) => {
  const value = resolveFirstDefined([itemObj, item], keys);
  return processDateField(value);
};

// Special resolver for Author: tries user fields, then AuthorEmail -> createUserFromEmail
const resolveAuthorPreferred = (itemObj: any, item: any) => {
  const userValue = resolveFirstDefined(
    [itemObj, item],
    ["Author", "createdBy"]
  );
  if (userValue !== null) {
    return processUserField(userValue);
  }
  const emailValue = resolveFirstDefined([itemObj, item], ["AuthorEmail"]);
  if (emailValue && typeof emailValue === "string") {
    return createUserFromEmail(emailValue);
  }
  return processUserField(null);
};

export const prepareResponse = (
  listName: string,
  response: any,
  strapiUrl: string,
  isLocalDate?: boolean
) => {
  // console.log("prepareResponse input:", response);

  if (!response || !response.data || !Array.isArray(response.data)) {
    console.warn("Invalid response format for listName:", listName);
    return [];
  }

  let convertedArr: Record<string, any>[] = [];
  const fieldsObj = listFields[listName as keyof typeof listFields];

  response.data.forEach((item: any) => {
    let itemObj: Record<string, any> = {};

    // Получаем маппинг для текущего списка
    const fieldMapping = getFieldMapping(listName);

    // // Специальная обработка для создания Responsible из ResponsibleEmail
    if (item.ResponsibleEmail && !item.Responsible) {
      item.Responsible = createUserFromEmail(item.ResponsibleEmail);
    }

    itemObj.Author = resolveAuthorPreferred(itemObj, item);
    itemObj.Editor = resolveUserPreferred(itemObj, item, [
      "Editor",
      "updatedBy",
    ]);
    itemObj.Created = resolveDatePreferred(itemObj, item, [
      "Created",
      "createdAt",
    ]);
    itemObj.Modified = resolveDatePreferred(itemObj, item, [
      "Modified",
      "updatedAt",
    ]);

    // Обрабатываем все поля из объекта
    Object.keys(item).forEach((key) => {
      // Пропускаем системные поля
      let targetKey = key;
      if (fieldMapping && fieldMapping[key]) {
        targetKey = fieldMapping[key];
      }

      const fieldType = key === "id" ? fieldsObj["ID"] : fieldsObj[targetKey];
      const value = key === "id" ? item.id : item[key];

      try {
        // Проверяем маппинг полей

        // Если поле не найдено в конфигурации, добавляем как есть
        if (!fieldType) {
          itemObj[targetKey] = value;
          return;
        }

        switch (fieldType) {
          case FIELDS_TYPES.ID:
            itemObj["ID"] = Number(value) || 0;
            break;

          case FIELDS_TYPES.DATE:
            itemObj[targetKey] = isLocalDate && value || processDateField(value);
            break;

          case FIELDS_TYPES.STRING:
            if (value === null) {
              itemObj[targetKey] = "";
            } else if (typeof value === "object") {
              itemObj[targetKey] = String(value.title);
            } else {
              itemObj[targetKey] =
                typeof value === "string" ? value : String(value);
            }
            break;

          case FIELDS_TYPES.NUMBER:
            itemObj[targetKey] = Number(value) || 0;
            break;

          case FIELDS_TYPES.LOOKUP:
            // Обработка связанных данных (одиночная связь)

            itemObj[targetKey] = processRelationField(value);

            break;

          case FIELDS_TYPES.MULTI_LOOKUP:
            // Обработка связанных данных (множественная связь)

            itemObj[targetKey] = value && value.map((item: any) =>
              processRelationField(item)
            );

            break;

          case FIELDS_TYPES.MEDIA:
            itemObj[targetKey] = processMediaField(value);
            break;

          case FIELDS_TYPES.LINK:
            itemObj[targetKey] = processLinkField(value);
            break;

          case FIELDS_TYPES.USER:
            itemObj[targetKey] = processUserField(value);
            break;

          case FIELDS_TYPES.MULTI_USER:
            itemObj[targetKey] = value.map((item: any) =>
              processUserField(item)
            );
            break;

          case FIELDS_TYPES.JSON:
            itemObj[targetKey] = processJsonField(value);
            break;

          default:
            // Для остальных типов добавляем как есть
            itemObj[targetKey] = value;
            break;
        }
      } catch (error) {
        console.error(
          `Error processing field ${key} for list ${listName}:`,
          error
        );
        // Fallback к исходному значению
        const fallbackKey =
          fieldMapping && fieldMapping[key] ? fieldMapping[key] : key;
        itemObj[fallbackKey] = value;
      }
    });

    // Добавляем системные поля с приоритетом слева направо и фолбэком
    // Author:   Author -> createdBy -> default user
    // Editor:   Editor -> updatedBy -> default user
    // Created:  Created -> createdAt  -> null
    // Modified: Modified -> updatedAt  -> null

    convertedArr.push(itemObj);
  });

  return convertedArr;
};

// Вспомогательные функции для обработки различных типов полей
const processJsonField = (value: any) => {
  if (!value) return null;
  return JSON.stringify(value);
};

const processRelationField = (value: any) => {
  if (!value) return null;

  const result: any = {
    get_lookupId: () => value.id,
    get_lookupValue: () =>
      value.Title ||
      value.Name ||
      value.title ||
      value.name ||
      value.Workstation,
    get_url: () => resolveResourceUrl(value.url, strapiAPIUrl),
    get_metadata: () => value,
  };

  // // Добавляем все дополнительные поля из связанного объекта
  // Object.keys(value).forEach((key) => {
  //   if (key !== "id" && key !== "Title" && key !== "Name" && key !== "title" && key !== "name" && key !== "url") {
  //     result[key] = value[key];
  //   }
  // });

  return result;
};

const processUserField = (value: any) => {
  if (!value) return null;

  const user = store.getState().users.items[value.email];

  if (user) {
    return {
      get_lookupId: () => user.Id,
      get_lookupValue: () => user.DisplayName,
      get_email: () => user.Email,
      get_metadata: () => user,
    };
  }
  const result: any = {
    get_lookupId: () => value.id,
    get_lookupValue: () => `${value.Name} (${value.PersonalNumber})`,
    get_email: () =>
      (value.email && value.email.toLowerCase().trim()) ||
      value.username ||
      null,
    get_metadata: () => value,
  };
  // Добавляем все дополнительные поля из связанного объекта пользователя
  Object.keys(value).forEach((key) => {
    if (
      key !== "id" &&
      key !== "Name" &&
      key !== "username" &&
      key !== "email"
    ) {
      result[key] = value[key];
    }
  });
  return result;
};

const processMediaField = (value: any) => {
  if (!value) return null;

  // Если это объект с данными медиа-файла
  if (typeof value === "object" && value.id) {
    return {
      id: value.id,
      url: resolveResourceUrl(value.url, strapiMediaUrl),
      name: value.name,
      alternativeText: value.alternativeText,
      caption: value.caption,
      width: value.width,
      height: value.height,
      size: value.size,
      mime: value.mime,
      formats: value.formats,
      documentId: value.documentId,
    };
  }

  return value;
};

const processLinkField = (value: any) => {
  if (!value) return null;

  // Если это объект с данными медиа-файла
  if (typeof value === "object") {
    return {
      get_url: () => resolveResourceUrl(value.url, strapiAPIUrl),
    };
  } else {
    return {
      get_url: () => value,
    };
  }
};

const processComponentField = (value: any, fieldName: string) => {
  // Компоненты приходят как объекты или массивы объектов
  return value;
};

const processDynamicZoneField = (value: any, fieldName: string) => {
  // Динамические зоны могут содержать разные типы компонентов
  return value;
};

const processLocalizationsField = (value: any, fieldName: string) => {
  // Локализации приходят как массив объектов
  return value;
};

const processDateField = (value: any) => {
  if (!value) return null;

  // Если это строка даты, преобразуем в Date объект
  if (typeof value === "string") {
    const date = new Date(value);
    return changeTimeZone(date, "Europe/Moscow");
  }

  // Если это уже Date объект
  if (value instanceof Date) {
    return changeTimeZone(value, "Europe/Moscow");
  }

  return changeTimeZone(value, "Europe/Moscow");
};
